/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiExpertTradeAreaFromJSON, StreemApiExpertTradeAreaToJSON, } from './';
export function StreemApiGetCompanyHoursOfOperationResponseFromJSON(json) {
    return StreemApiGetCompanyHoursOfOperationResponseFromJSONTyped(json, false);
}
export function StreemApiGetCompanyHoursOfOperationResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'expertTradeArea': !exists(json, 'expert_trade_area') ? undefined : (json['expert_trade_area'].map(StreemApiExpertTradeAreaFromJSON)),
    };
}
export function StreemApiGetCompanyHoursOfOperationResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'expert_trade_area': value.expertTradeArea === undefined ? undefined : (value.expertTradeArea.map(StreemApiExpertTradeAreaToJSON)),
    };
}
//# sourceMappingURL=StreemApiGetCompanyHoursOfOperationResponse.js.map